import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: {
    prepared: () => i18n.t(i18nKeys.activationKitSplash__title__prepared),
    shipped: () => i18n.t(i18nKeys.activationKitSplash__title__shipped),
    delivered: () => i18n.t(i18nKeys.activationKitSplash__title__delivered),
  },
  whatsInIt: () => i18n.t(i18nKeys.activationKitSplash__whatsInIt),
  statusLabel: () => i18n.t(i18nKeys.activationKitSplash__statusLabel),
  shippingDate: {
    prepared: () =>
      i18n.t(i18nKeys.activationKitSplash__shippingDate__prepared),
    shipped: date =>
      i18n.t(i18nKeys.activationKitSplash__shippingDate__shipped, { date }),
    delivered: date =>
      i18n.t(i18nKeys.activationKitSplash__shippingDate__delivered, { date }),
  },
  trackPackage: () => i18n.t(i18nKeys.activationKitSplash__trackPackage),
  shipToLabel: () => i18n.t(i18nKeys.activationKitSplash__shipToLabel),
  button: {
    gotIt: () => i18n.t(i18nKeys.activationKitSplash__gotItButton),
    continue: () => i18n.t(i18nKeys.activationKitSplash__continueButton),
    receivedIt: () => i18n.t(i18nKeys.activationKitSplash__receivedItButton),
    noReceivedIt: () =>
      i18n.t(i18nKeys.activationKitSplash__noReceivedItButton),
  },
}
